import {
  ProductReplacementPayload,
  ReplacementReferenceType,
} from "../../api/dispatchReplacement.api";

export interface ProductReplacementFormValues {
  serialNumberToReplace: string;
  replacementSerialNumber: string;
  reason: string;
  beneficiaryType: ReplacementReferenceType;
  beneficiaryId: string;
}

export const validateProductReplacement = (
  values: ProductReplacementFormValues,
): string | null => {
  const serialNumberToReplace = values.serialNumberToReplace.trim();
  const replacementSerialNumber = values.replacementSerialNumber.trim();

  if (!serialNumberToReplace || !replacementSerialNumber) {
    return "Enter both serial numbers.";
  }
  if (
    !/^\d{10}$/.test(serialNumberToReplace) ||
    !/^\d{10}$/.test(replacementSerialNumber)
  ) {
    return "Serial numbers must each be exactly 10 numeric digits.";
  }
  if (serialNumberToReplace === replacementSerialNumber) {
    return "The old and replacement serial numbers must be different.";
  }
  if (!values.reason.trim()) {
    return "Enter a reason for the replacement.";
  }
  if (!values.beneficiaryId.trim()) {
    return "Select exactly one beneficiary.";
  }

  return null;
};

export const buildProductReplacementPayload = (
  values: ProductReplacementFormValues,
): ProductReplacementPayload => {
  const sharedFields = {
    serialNumberToReplace: values.serialNumberToReplace.trim(),
    replacementSerialNumber: values.replacementSerialNumber.trim(),
    reason: values.reason.trim(),
  };
  const beneficiaryId = values.beneficiaryId.trim();

  if (values.beneficiaryType === "salesRep") {
    return { ...sharedFields, salesRepId: beneficiaryId };
  }
  if (values.beneficiaryType === "user") {
    return { ...sharedFields, userId: beneficiaryId };
  }
  return { ...sharedFields, customerRegistrationId: beneficiaryId };
};
